/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  InverterUpgradeInput,
  ResponseStatusType,
} from '..';
import {
  serializeInverterUpgradeInput,
} from '..';
import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface SendInverterUpgradeInput {
  input: InverterUpgradeInput;
}
const build = (_query: DocumentNode, input: SendInverterUpgradeInput, name = 'QueryResult') => {
  const bQuery = `
  mutation ${ name }(`+
    ( input.input !== undefined ? `$input: InverterUpgradeInput = ${serializeInverterUpgradeInput(input.input)}` : '' ) + `){
    sendInverterUpgrade(
      ${ input.input !== undefined ? 'input: $input,' : '' }
    ){
      ...responsestatustype
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class SendInverterUpgradeMutation {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment responsestatustype on ResponseStatusType { ... }
   */
  async execute(_query: DocumentNode, input: SendInverterUpgradeInput): Promise<apollo.FetchResult< { sendInverterUpgrade: Partial<ResponseStatusType> }, Record<string, any>, Record<string, any>>> {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    return await client?.mutate<{ sendInverterUpgrade: Partial<ResponseStatusType> }>({ mutation: build(_query, input) });
  }
}
